import {Profile} from "@simplebooth/webkit"
import {Link} from "react-router-dom"
import ReactGA from "react-ga"
import {Avatar as MuiAvatar, Box, SxProps, Theme} from "@mui/material"
import "./Avatar.module.scss"

interface AvatarProps {
  profile: Profile
  sx?: SxProps<Theme>
}

const SIZE = 54

export default function Avatar({profile, sx}: AvatarProps) {
  return (
    <Box sx={sx}>
      <Link
        to={`/profiles/${profile.username.toLowerCase()}`}
        onClick={() => ReactGA.event({category: "Profile Links", action: "Open Profile from Top Avatar", label: profile.username})}
      >
        <MuiAvatar
          src={profile.avatar?.url}
          alt="Profile avatar"
          sx={{
            width: SIZE,
            height: SIZE,
            border: "2px solid #ffffff",
            boxShadow: "1px 1px 9px -5px rgba(0, 0, 0, 0.7)",
            transition: "transform 0.2s ease-in-out",
            animation: "avatarIn ease-in-out 0.6s",
            "&:hover": {
              transform: "scale(1.1)",
            },
          }}
        />
      </Link>
    </Box>
  )
}
